import React, { FunctionComponent } from "react"
import { Controller, useFormContext } from "react-hook-form"
import { ArtPieceTypes } from "../../../api/Definitions"
import FormInput from "../../../components/Form/Inputs/FormInput"
import Textarea from "../../../components/Form/Inputs/Textarea"
import AsyncSelectInput, {
  FormAsyncSelectInput,
} from "../../../components/Form/Select/AsyncSelect"
import SelectInput, {
  FormSelectInput,
} from "../../../components/Form/Select/Select"
import TextToSpeech from "../../../components/TextToSpeech/TextToSpeech"
import Upload from "../../../components/Upload/Upload"
import { iArtist } from "../../../definitions/Artists"
import { iResponse } from "../../../definitions/interfaces"
import { get } from "../../../store/data/actions"
interface iProps {
  onCreateAudio?: (data: any) => void
}

const ArtPieceOverview: FunctionComponent<iProps> = ({ onCreateAudio }) => {
  const loadArtists = async (input: string) => {
    try {
      const result = await get<iResponse<iArtist[]>>({
        link: "/v1/artists-list",
        query: { name: input },
      })

      return result.data
    } catch (e) {
      console.error(e)
    }
  }

  const { watch } = useFormContext()
  const { shrFullDescription: description, descriptionAudio } = watch([
    "shrFullDescription",
    "descriptionAudio",
  ])
  // const description = watch("shrFullDescription")

  return (
    <div className="scrollable container">
      <div className="row">
        <div className="col-6">
          <FormInput
            name="shrTitle"
            label={"Title"}
            validation={{ required: "This field is required!" }}
          />
          <Controller
            render={({ value, onChange }) => (
              <FormAsyncSelectInput
                value={value}
                onChange={onChange}
                name={"shrArtistId"}
                placeholder={"Select artist"}
                loadOptions={loadArtists}
                defaultOptions
                label="Artist"
              />
            )}
            rules={{ required: "This field is required!" }}
            name={"shrArtistId"}
          />
          <Controller
            render={({ value, onChange }) => (
              <FormSelectInput
                value={value}
                onChange={onChange}
                name="shrType"
                options={ArtPieceTypes}
                label="Type"
              />
            )}
            rules={{ required: "This field is required!" }}
            name="shrType"
            label="Type"
          />
          <FormInput name="externalUrl" label="External Url" />
        </div>
        <div className="col-6">
          <Controller
            render={({ value, onChange }) => (
              <Textarea value={value} onChange={onChange} label="Description" />
            )}
            name="shrFullDescription"
          />
          {!descriptionAudio && (
            <TextToSpeech
              text={description}
              onCreate={(data) => {
                console.log(data)
                onCreateAudio && onCreateAudio(data)
              }}
            />
          )}
          <Controller
            name="descriptionAudio"
            render={({ value }) => (
              <Upload
                name="descriptionAudio"
                fileCollection="Files_TextToSpeech"
                maxFiles={1}
                initialFiles={[value || ""]}
                label="Description Audio"
              />
            )}
          />
        </div>
      </div>
    </div>
  )
}

export default ArtPieceOverview
